import { StatusResult } from '../shared/enum/StatusResult';

export interface InfluencerUploadResultModel {
    id: number,
    quantityInserted: number,
    quantityDuplicated: number,
    quotasQuantity: number,
    quotasInput: number,
    quantityTotal: number,  
    quantityRemaining: number,  
    row:any
    insertedQuotas: number,  
    quotaOverflow: boolean,
    registeredInfluencersMessage: string;
    message: string,
    title: string,
    property: string,
    status: StatusResult
}

export const InfluencerUploadResultInitial: InfluencerUploadResultModel = {
    id: 0,
    quantityInserted: 0,
    quantityDuplicated: 0,
    quantityTotal: 0,
    quantityRemaining: 0,  
    quotasQuantity: 0,
    row:{},
    quotasInput: 0,
    insertedQuotas: 0,  
    quotaOverflow: false,
    message: '',
    title: '',
    property: '', 
    registeredInfluencersMessage: '',
    status: StatusResult.DEFAULT
};